import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AccionAnualModel, AreasAnualesModel, EstrategiasAreasModel } from 'src/app/model/FaseAnual.model';
import { UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-estrategia-anual-seguimiento',
  templateUrl: './estrategia-anual-seguimiento.component.html',
  styleUrls: ['./estrategia-anual-seguimiento.component.css']
})
export class EstrategiaAnualSeguimientoComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;

  @Input() estrategiaData : EstrategiasAreasModel;
  @Input() areaNumber : number;
  @Input() readonly : boolean;

  dataJardin : JardinModel;
  
  cargando: boolean;
  uniEducativa = new UnidadEducativaModel();

  constructor(
    private api: apiService,
  ) {}

  ngOnInit(): void {     
    this.cargando = true;
    this.cargaInicial();
  }

  cargaInicial(){ 
    this.dataJardin = this.api.dataJardin;
  }


}
